var _effectorFileName = "/src/shared/components/logo/logo.tsx";
import Link from 'next/link';
import LogoRuDarkIcon from '@/shared/components/icons/logo/logo-dark';
import LogoRuLightIcon from '@/shared/components/icons/logo/logo-light';
import { cn } from '@/shared/lib/cn';
interface LogoProps {
  className?: string;
}
export const Logo = (props: LogoProps) => {
  const {
    className
  } = props;
  return <Link aria-label="Перейти на главную" href="/">
      <LogoRuDarkIcon className={cn('hidden h-7 w-auto shrink-0 text-black dark:block xs:h-8 sm:h-10', className)} />
      <LogoRuLightIcon className={cn('block h-7 w-auto shrink-0 text-black dark:hidden xs:h-8 sm:h-10', className)} />
    </Link>;
};